import { Injectable } from "@angular/core";
import { AppState } from "../app.state";
import { Store } from "@ngrx/store";
import { filter, Observable, pluck } from "rxjs";
import { HomeLobbyComponent, HomeLobbyComponentId, HomeLobbyState } from "./homeLobby.state";
import * as HomeLobbyActions from './homeLobby.actions';

@Injectable()
export class HomeLobbyStateDispatcher {
    constructor(
        private store: Store<AppState>,
    ) {}

    /** Returns an Observable of non-null HomeLobbyState */
    public getHomeLobbyState(): Observable<HomeLobbyState> {
        return this.store.select(state=> state.homeLobby).pipe(filter(homeLobbyState => homeLobbyState != null));
    }

    public getActivatedComponent(): Observable<HomeLobbyComponent> {
        return this.getHomeLobbyState().pipe(pluck('activeComponent'));
    }

    public activateComponent(componentId: HomeLobbyComponentId) {
        this.store.dispatch(HomeLobbyActions.activateHomeLobbyComponent({component: {componentId}}));
    }
}
